<template>
  <div>
    <search-form ref="SearchForm" @search="handleSearch" />
    <el-row>
      <el-button
        :type="useType == 1 || useType == 3 ? 'primary' : 'danger'"
        size="small"
        @click="handleSave"
      >
        {{ useType == 1 || useType == 3 ? '保存所选' : '临时禁用所选' }}
      </el-button>
    </el-row>
    <el-pagination
      @size-change="optSearch"
      @current-change="optSearch"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    />
    <el-table
      :data="tableData"
      v-loading="loading"
      @selection-change="onSelection"
      border
      fit
      stripe
    >
      <el-table-column type="selection" min-width="55" align="center" />
      <el-table-column
        prop="sortNum"
        label="序号"
        min-width="60"
        align="center"
      />
      <el-table-column prop="mavinName" label="姓名" min-width="130" />
      <el-table-column prop="safeIdCard" label="身份证" min-width="150" />
      <el-table-column label="性别/民族/年龄/专业技术职称" min-width="175">
        <template slot-scope="scope">
          {{ scope.row.sex }}、{{ scope.row.nation }}、{{ scope.row.age }}
          <div>
            {{ scope.row.appellation }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="工作单位" min-width="150" />
      <el-table-column label="人员行业分类/行政级别" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.industry }}、{{ scope.row.executLevel }}
        </template>
      </el-table-column>
      <el-table-column
        prop="speName"
        label="主要从事的专业方向（研究学科）"
        min-width="175"
      />
      <el-table-column prop="minorName" label="二级专业" min-width="100" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleView(scope.row.mavinEid)">
            详情
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="optSearch"
      @current-change="optSearch"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus.js';
import { optSearch, optSave } from '@/api/position/gains/mavin.js';
import SearchForm from '@/components/SearchPositionMavin/Board.vue';

export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      loading: false,
      tableData: [],
      total: 0,
      mavinEids: [] // 选中数组
    };
  },
  props: {
    useType: {
      type: Number,
      default: 0
    }
  },
  components: {
    SearchForm
  },
  methods: {
    /** 搜索按钮操作 */
    handleSearch(querys) {
      this.query.pageIndex = 1;
      if (querys) {
        Object.assign(this.query, querys);
      }
      this.optSearch();
    },
    handleView(mavinEid) {
      window.open(`/mavin/review/${mavinEid}`, 'handleView');
    },
    // 多选框选中数据
    onSelection(selection) {
      this.mavinEids = selection.map(item => item.mavinEid);
    },
    handleSave() {
      if (this.mavinEids.length == 0) {
        this.msgError('请您先选择专家！');
        return;
      }

      this.loading = true;
      optSave(this.$route.params.gainEid, {
        useType: this.useType,
        mavinEids: this.mavinEids
      }).then(() => {
        this.loading = false;
        this.msgSuccess();

        eventBus.$emit('eventSeled');
        this.mavinEids = [];
        this.optSearch();
      });
    },
    optSearch() {
      this.loading = true;
      optSearch(this.$route.params.gainEid, this.query).then(res => {
        this.tableData = res.items.datas;
        this.total = res.items.totalRecords;

        this.loading = false;
      });
    }
  },
  created() {
    eventBus.$on('eventOpt', () => {
      this.optSearch();
    });
    this.optSearch();
  }
};
</script>

<style></style>
